import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Country } from 'app/models';

export const CountriesActions = createActionGroup({
  source: 'countries',
  events: {
    'Set Countries': props<{ countries: Country[] }>(),
    'Get Countries': emptyProps(),
  },
});
